import { template as template_6107f9033e324f17b5b95135536015dc } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import BsButton from 'ember-bootstrap/components/bs-button';
import Link from 'eflex/components/link';
import UserDropdown from 'eflex/components/user-dropdown';
import { fn } from '@ember/helper';
import NavBar from 'eflex/components/nav-bar';
import NavBarHelp from 'eflex/components/nav-bar-help';
import MainHeaderPanels from 'eflex/constants/main-header-panels';
class MainHeader extends Component {
    @service
    session;
    @tracked
    activePanel = MainHeaderPanels.NAV;
    get navIsOpen() {
        return this.activePanel === MainHeaderPanels.NAV;
    }
    get helpIsOpen() {
        return this.activePanel === MainHeaderPanels.HELP;
    }
    toggle = (panel)=>{
        this.activePanel = (this.activePanel === panel) ? MainHeaderPanels.NONE : panel;
    };
    static{
        template_6107f9033e324f17b5b95135536015dc(`
    <div class="main-header bg-brand hidden-print d-flex flex-column align-items-center">
      <div class="header-menu flex-fill d-flex flex-column">
        <div class="row flex-column align-items-center g-0 h-100">
          <div class="col-auto">
            <Link
              class="home-page btn btn-epicor-nav p-0"
              @route="landingPage"
            >
              <img
                src='/images/icons/home.svg'
              />
            </Link>
          </div>
          {{#if this.session.isActuallyAuthenticated}}
            <div class="col-auto">
              <BsButton
                @type="epicor-nav"
                @onClick={{fn this.toggle MainHeaderPanels.NAV}}
                class="menu-btn p-0 {{if this.navIsOpen "active"}}">
                <img
                  src='/images/icons/menu.svg'
                />
              </BsButton>
            </div>
            <div class="col-auto mt-auto">
              <BsButton
                @type="epicor-nav"
                @onClick={{fn this.toggle MainHeaderPanels.HELP}}
                class="help-btn p-0 {{if this.helpIsOpen "active"}}">
                <img
                  src='/images/icons/help-and-support.svg'
                />
              </BsButton>
            </div>
            <div class="col-auto">
              <UserDropdown
                @showHeaderButtons={{true}}
                class='z-top-menu'
              />
            </div>
          {{/if}}
        </div>
      </div>
    </div>

    {{#unless @isTesting}}
      {{#if this.session.isAuthenticated}}
        {{#if this.navIsOpen}}
          <NavBar />
        {{/if}}
        {{#if this.helpIsOpen}}
          <NavBarHelp />
        {{/if}}
      {{/if}}
    {{/unless}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default MainHeader;
